export default "__VITE_ASSET__Blv0wWPK__"